import { Routes, Route } from "react-router-dom";
import EstadisticaCliente from "./pages/EstadisticaCliente";

function App() {
  return (
    <Routes>
            <Route path="/" element={<EstadisticaCliente />} />
    </Routes>
  );
}

export default App;
